import { render, staticRenderFns } from "./NewsSpotlight.vue?vue&type=template&id=4a09505c&scoped=true&"
import script from "./NewsSpotlight.vue?vue&type=script&lang=js&"
export * from "./NewsSpotlight.vue?vue&type=script&lang=js&"
import style0 from "./NewsSpotlight.vue?vue&type=style&index=0&id=4a09505c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a09505c",
  null
  
)

export default component.exports